import { Outlet, useLocation } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';

export function MedicalLayout() {
  // SHCT-718 — a render crash inside a screen must degrade to a contained
  // fallback, not blank the whole SPA. `resetKey={pathname}` means navigating
  // away from the broken screen clears the error by itself.
  const { pathname } = useLocation();

  return (
    <AppShell>
      <ErrorBoundary resetKey={pathname}>
        <Outlet />
      </ErrorBoundary>
    </AppShell>
  );
}
